/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */
// import {getSelectedProductIdFromActionInput, ProductInput, getSimpleProductsAction } from '@msdyn365-commerce-modules/retail-actions';
import * as Msdyn365 from '@msdyn365-commerce/core';
import axios from 'axios';
import { ProductWarehouses } from './AlternateItemsEntity.g';

/**
 * GeneraProductWarehouseDetails Input Action
 */
export class GeneraProductListWarehouseDetailsInput implements Msdyn365.IActionInput {
    public ItemIds: string[];

    public channelId: number;

    public config: any;

    constructor(ItemIds: string[], channelId: number, config: any) {
        this.channelId = channelId;
        this.ItemIds = ItemIds;
        this.config = config;
    }


    // TODO: Determine if the results of this get action should cache the results and if so provide
    // a cache object type and an appropriate cache key
    public getCacheKey = () => `GeneraProductListWarehouseDetailsInput`;
    public getCacheObjectType = () => 'ProductListWarehouses';
    public dataCacheType = (): Msdyn365.CacheType => 'none';
}

// TODO: Create a data model here or import one to capture the response of the action
export interface IGeneraProductListWarehouseDetailsData {
    warehouseDetails: ProductWarehouses[];
}

/**
 * TODO: Use this function to create the input required to make the action call
 */
// const createInput = (inputData: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
//     // return new GeneraProductWarehouseDetailsInput();
//     const productId = getSelectedProductIdFromActionInput(inputData);
//     if(productId)
//     {
//         return new GeneraProductListWarehouseDetailsInput(+productId, +inputData.requestContext.apiSettings.channelId, inputData.config);

//     }
//     throw new Error('Unable to create SelectedVariantInput, no productId found on module config or query');
// };

/**
 * TODO: Use this function to call your action and process the results as needed
 */
export async function getCurrentProductListWarehouseDetailsAction(input: GeneraProductListWarehouseDetailsInput, ctx: Msdyn365.IActionContext): Promise<ProductWarehouses[]> {
    // const apiSettings = Msdyn365.msdyn365Commerce.apiSettings;
    // TODO: Uncomment the below line to get the value from a service
    // const response = await Msdyn365.sendRequest<IGeneraProductWarehouseDetailsData[]>('/get/example/id/1', 'get');
    let productWarehouseDtl:ProductWarehouses[] = [];
    // const prod:ProductInput[] = new Array();
    // if(input.ItemIds)
    // input.ItemIds.forEach((itemid,idx)=>{
    //     prod.push(new ProductInput(itemid,ctx.requestContext.apiSettings));
    // });
    //  var prodDtl = await getSimpleProductsAction(prod,ctx);
    const itemIdsFilter:string[] = input.ItemIds.map((itemid,idx)=>{
        return `ItemNumber eq '${itemid}'`;
    });
    var formData = new URLSearchParams();
    formData.append('client_id',ctx.requestContext.app.config.clientId);
    formData.append('grant_type','client_credentials');
    formData.append('resource',ctx.requestContext.app.config.baseUrl);
    formData.append('client_secret',ctx.requestContext.app.config.clientSecret);

    var token = await (axios.post(`https://login.microsoftonline.com/${ctx.requestContext.app.config.tenentId}/oauth2/token`, formData).then((res) => { return res.data;}).catch((err)=> {return err;}));
    //  const jsObj = `{'_request':{'ItemNumber' : '${ prodDtl[0].ItemId }'}}`;
     const header = { headers: { 'Authorization': `bearer ${token.access_token}` } };
     const prodWarehouseDetails = await (axios.get(`${ctx.requestContext.app.config.axItemWarehouseUrl}?$filter=(${itemIdsFilter.join(' or ')}) and DistributionCenter eq Microsoft.Dynamics.DataEntities.NoYes'Yes'`, header).then((res) => { return res.data;}).catch((err)=> {console.log("axios error: ",err); return err;}));
     if(prodWarehouseDetails && prodWarehouseDetails.value)
    {
        productWarehouseDtl = prodWarehouseDetails.value;
    }
    return productWarehouseDtl;
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<ProductWarehouses[]>>getCurrentProductListWarehouseDetailsAction,
    // TODO: Give your data action a unique id
    id: 'getCurrentProductWarehouseDetailsAction'
    // input: createInput
    // TODO: Uncomment the below line if this is a meant to be a batched data action
    // isBatched: true
});
